<bootstrap-popup [id]="id"  [title]="'Relecture et validation annuelle'"  [displaySubject]="displaySubject" [modalSize]="'modal-lg'" [windowCloseButton]="true">
 <form role="form" class="form-horizontal">
		<div class="row">
		  <div *ngIf="planPrevention" class="col-md-12  mb-3">
		    <p>Je soussigné {{ user.lastName }} {{ user.firstName }} confirme avoir relu le plan de prévention</p>
		    <ul><li><b>{{ planPrevention.numeroPdp }}</b></li></ul>
		    <p>Je valide sa prolongation pour une année supplémentaire ce jour le {{ today | date: 'dd/MM/yyyy' }}</p>
		  </div>
		</div>
		<div class="form-group text-center">
			<button type="button" class="btn btn-success" style="margin-right: 10px" (click)="onRevaliderRequested()">
				Revalider
			</button>
			<button type="button" class="btn btn-danger" style="margin-right: 6px" (click)="onInvaliderRequested()" 
				title = "Invalider" [disabled]="waitingForServer">
				Invalider
			</button>
		</div>
</form>
</bootstrap-popup>